import api from './index';
//
let exports = {};

// 门店仓库-分页查询
exports.getShopWarehouseList = function (params, callback) {
    api.post('/shopStock/shop/warehouse/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 门店仓库-不分页查询
exports.getShopWarehouseNotPageList = function (params, callback) {
    api.post('/shopStock/shop/warehouse/list/notPage/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 门店仓库-根据id查询
exports.getShopWarehouse = function (params, callback) {
    api.post('/shopStock/shop/warehouse/get/by/id')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 门店仓库-保存
exports.saveShopWarehouse = function (params, callback) {
    api.post('/shopStock/shop/warehouse/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 门店仓库-修改
exports.updateShopWarehouse = function (params, callback) {
    api.post('/shopStock/shop/warehouse/update/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 设置默认门店仓库
exports.updateShopWarehouseDefaulted = function (params, callback) {
    api.post('/shopStock/shop/warehouse/defaulted/update/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 锁定/解锁门店仓库
exports.updateShopWarehouseLocked = function (params, callback) {
    api.post('/shopStock/shop/warehouse/locked/update/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 删除门店仓库
exports.deleteShopWarehouse = function (params, callback) {
    api.post('/shopStock/shop/warehouse/delete/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/shopStock.js
// module id = 24
// module chunks = 0